function submitVrRegistrationForm (event) {
  const form = $(event.currentTarget)
  const formData = form.serialize()
  const token = document.querySelector('meta[name=csrf-token]')

  $.ajax('/bank_employees/registrations', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': token ? token.content : null,
    },
    data: formData,
    cache: false,
  }).then(result => {
    if (result.self_registration === true) {
      $('#self_service').modal('show')
    } else {
      $('#no_self_service').modal('show')
    }
  }).catch(error => {
    $.each(error.responseJSON, (field, message) => {
      const input = form.find(`.${field}`)
      const errorMessage = input.siblings('.vr-banken__form-invalid-msg')
      const select2Container = input.siblings('.select2-container')

      input.addClass('invalid')
      select2Container.addClass('invalid')
      errorMessage.text(message)
    })
  })
}

function handleFormSubmit (event) {
  const { classList } = event.target

  if (classList.contains('vrBankenRegistration')) {
    event.preventDefault()
    submitVrRegistrationForm(event)
  }
}

$(() => {
  const form = $('#vr-managed-form, .vr-managed-form')

  if (form.length === 0) {
    return
  }

  form.on('submit', event => {
    const invalidInput = $(event.currentTarget).find('input:invalid')

    if (invalidInput.length === 0) {
      handleFormSubmit(event)
    } else {
      event.preventDefault()
    }
  })
})
